<template>
  <tooltip interactive :append-to="body" @click.prevent>
    <template #default>
      <div class="modal-icon" @click.prevent.stop="emit('client:call', $event)">
        <div class="flex h-full items-center justify-center">
          <icon-base :icon="IconTelephone" />
        </div>
      </div>
    </template>
    <template #content>
      <telephone-tooltip-content class="flex items-center space-x-2">
        <span>
          {{ telephoneNumber }}
        </span>
      </telephone-tooltip-content>
    </template>
  </tooltip>
</template>

<script setup lang="ts">
import { type Ref, ref } from "vue";

import { useContacts } from "@/hooks/contacts";
import { useDeals } from "@/hooks/deals";

import TelephoneTooltipContent from "@/components/communication/TelephoneTooltipContent.vue";
import IconTelephone from "@/components/icons/IconTelephone.vue";

import type { ApplicationWithContactData } from "@/models/applications";

const emit = defineEmits<{
  "client:call": [MouseEvent];
}>();

const body = ref(document.body);

const { activeDeal } = useDeals();

const { telephoneNumber } = useContacts(
  activeDeal as unknown as Ref<ApplicationWithContactData>
);
</script>
